import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
    FormActionButtonsComponent
} from "../../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";
import {
    AppAlertService,
    ParametersService,
    SettingsNotificationsDefaultService,
    SettingsNotificationsService, SettingsService, SubtitlesService
} from "../../../core";
import {NgOptimizedImage} from "@angular/common";
import {
    HoldWrapperComponent
} from "../../../common/hold-wrapper/hold-wrapper.component";
import {NotificationConfig, TimeType} from "../../../models";
import {FormsModule} from "@angular/forms";


@Component({
  selector: 'notification-time',
  standalone: true,
    imports: [
        FormActionButtonsComponent,
        FormButtonComponent,
        NgOptimizedImage,
        HoldWrapperComponent,
        FormsModule,

    ],
  templateUrl: './notification-time.component.html',
  styleUrl: './notification-time.component.scss'
})
export class NotificationTimeComponent implements OnInit {
    @Output() close = new EventEmitter();
    @Input({ required: true }) notificationType!: keyof NotificationConfig;
    @Input({ required: true }) isTurnedOnByToggleBtn!: keyof NotificationConfig | '';

    constructor(
        private appAlert: AppAlertService,
        private parameters: ParametersService,
        private settings: SettingsService,
        public settingsNotifications: SettingsNotificationsService,
        private settingsNotificationsDefault: SettingsNotificationsDefaultService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit() {
        this.settingsNotifications.diffHours();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    closeForm(): void {
        this.close.emit();
    }

    showTime(range: TimeType): string {
        let time = this.settingsNotifications.time[range].hour + ':';

        if (this.settingsNotifications.time[range].minute < 10){
            time += '0';
        }
        time += this.settingsNotifications.time[range].minute;

        return time;
    }

    setNotificationTime() {
        if (this.parameters.demoAccount()) {
            this.appAlert.openDemoAccountDialog();
            return;
        }

        const config = this.settingsNotificationsDefault.notificationConfig.getValue();
        config[this.notificationType] = this.settingsNotifications.time;

        if (!this.isTurnedOnByToggleBtn && !config[this.notificationType].enable) {
            config[this.notificationType].enable = true;
        }
        this.settingsNotificationsDefault.notificationConfig.next(config);

        const selectedUdid = this.settings.getSelectedUdid();
        this.settingsNotifications.setNotificationTime(selectedUdid, this.notificationType);
    }
}
